import { render, staticRenderFns } from "./cart_items.vue?vue&type=template&id=4b7ced83&"
import script from "./cart_items.vue?vue&type=script&lang=js&"
export * from "./cart_items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports